import Base from '@/models/Base'
import type { IAppUser } from '@/interfaces/app-user/IAppUser'
import type { IAddress } from '@/interfaces/IAddress'
import type { IUserNextOfKinDetail } from '@/interfaces/users/IUserNextOfKinDetail'
import NextOfKinDetail from '@/models/NextOfKinDetail'
import Address from '@/models/Address'

class AppUser extends Base implements IAppUser {
  name: string
  userName: string
  phoneNumber: string
  email: string
  createdAt: string
  updatedAt: string
  archivedAt: string
  creatorId: string
  updatorId: string
  designation: string
  teamTitle: string
  employeeCode: string
  alternatePhoneNumber: string
  dateOfBirth: string
  nextOfKinDetail: IUserNextOfKinDetail
  address: IAddress
  roles: any[]
  accesses: any[]

  constructor(appUser?: any) {
    super(appUser)
    this.name = appUser?.name
    this.userName = appUser?.userName
    this.phoneNumber = appUser?.phoneNumber
    this.email = appUser?.email
    this.createdAt = appUser?.createdAt
    this.updatedAt = appUser?.updatedAt
    this.archivedAt = appUser?.archivedAt
    this.creatorId = appUser?.creatorId
    this.updatorId = appUser?.updatorId
    this.designation = appUser?.designation
    this.teamTitle = appUser?.teamTitle
    this.employeeCode = appUser?.employeeCode
    this.alternatePhoneNumber = appUser?.alternatePhoneNumber
    this.dateOfBirth = appUser?.dateOfBirth
    this.nextOfKinDetail = new NextOfKinDetail(appUser?.nextOfKinDetail)
    this.address = new Address(appUser?.address)
    this.roles = appUser?.roles
    this.accesses = appUser?.accesses
  }
}

export default AppUser
